import { Component, Inject, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
    BookRideStatus,
    NotificationFacade,
    PurchaseFacade,
    RidePlannerFacade,
    ShoppingCartFacade,
    ShoppingCartState
} from '@ridango/components';
import { AdyenResultStatus, BaseComponent, CoreFacade, Language } from '@ridango/core';
import Env from '@ridango/core/env';

import { combineLatest, Observable } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import { HelperService } from '../../shared/services/helper.service';

@Component({
    templateUrl: './payment-result-page.component.html'
})
export class PaymentResultPageComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
    steps$: Observable<any[]> = this.purchaseFacade.purchaseSteps$;
    activeStep$: Observable<number> = this.purchaseFacade.activePurchaseStep$;
    bookingId$: Observable<number> = this.ridePlannerFacade.bookingId$;
    cart$: Observable<ShoppingCartState> = this.cartFacade.cart$;
    docNums$: Observable<any[]> = this.cartFacade.docNums$;
    selectedLanguage$: Observable<Language> = this.coreFacade.selectedLanguage$;

    activeStep: number;
    steps = [];

    adyenResultStatusEnum = AdyenResultStatus;
    resultCode: string;
    selectedLanguageCode: string;
    isMobile = false;

    constructor(
        @Inject('ENV') public environment: Env,
        private route: ActivatedRoute,
        private purchaseFacade: PurchaseFacade,
        private cartFacade: ShoppingCartFacade,
        private notifications: NotificationFacade,
        private ridePlannerFacade: RidePlannerFacade,
        private coreFacade: CoreFacade,
        private helperService: HelperService
    ) {
        super();
        this.isMobile = this.environment.CHANNEL === 'mobile';
    }

    ngOnInit() {
        this.route.queryParams
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((params) => (this.resultCode = params['resultCode'] || params['result'] || null));

        this.ridePlannerFacade.bookingStatus$.pipe(take(1)).subscribe((bookingStatus) => {
            if (bookingStatus === BookRideStatus.PENDING) {
                this.steps = [
                    'BOOK_RIDE_PLAN_RIDE',
                    'BOOK_RIDE_SPECIFY_RIDE',
                    'BOOK_RIDE_REVIEW_RIDE',
                    'BOOK_RIDE_PAID'
                ];

                this.ridePlannerFacade.setStep(5);
                this.ridePlannerFacade.step$.pipe(take(1)).subscribe((step) => {
                    this.activeStep = step;
                });

                combineLatest([this.cart$, this.bookingId$])
                    .pipe(take(1))
                    .subscribe(([cart, bookingId]) => {
                        this.ridePlannerFacade
                            .linkOrderWithShoppingCart(bookingId, cart.shopping_cart_id)
                            .pipe(takeUntil(this.componentDestroyed$))
                            .subscribe();
                    });
            } else {
                this.purchaseFacade.purchaseSteps$.pipe(takeUntil(this.componentDestroyed$)).subscribe((steps) => {
                    this.steps = steps;
                });

                if (this.environment.THEME_NAME === 'vl') {
                    this.purchaseFacade.setActiveWalletPurchaseStep(4);
                } else {
                    this.purchaseFacade.setActiveWalletPurchaseStep(3);
                }

                this.purchaseFacade.activePurchaseStep$.pipe(take(1)).subscribe((activeStep) => {
                    this.activeStep = activeStep;
                });
            }
        });

        this.steps$.pipe(take(1)).subscribe((steps) => {
            if (!steps.length) {
                this.purchaseFacade.setWalletPurchaseSteps([
                    'TICKET_TEXT_ADD_DATA',
                    'TICKET_TEXT_PAYMENT',
                    'TICKET_TEXT_TICKETS'
                ]);
            }
        });

        this.selectedLanguage$.pipe(takeUntil(this.componentDestroyed$)).subscribe((l) => {
            this.selectedLanguageCode = l?.code;
        });
    }

    ngAfterViewInit() {
        this.scrollToTop();
    }

    scrollToTop() {
        if (this.isMobile) {
            this.helperService.scrollToTop();
        }
    }

    clearNotifications() {
        this.notifications.removeAll();
    }
}
